import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/client-layout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
